module.exports = __webpack_public_path__ + "img/LM23.f38dfbb7.png";